import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ContactPayeeGroupInterceptor implements HttpInterceptor {
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if ((request.url.includes('/api/contact-manager/client-api/v2/contacts') && request.method === 'GET' ) || (request.url.includes('api/contact-manager/client-api/v2/contacts/filter') && request.method === 'POST') ) {
            const params = request.params;
            if (params.has('size') && params.get('size') === "NaN") {
                const newReq = request.clone({
                    params: new HttpParams().set('size', 10).set('from', params.get('from')).set('targetSaId', params.get('targetSaId'))
                });
                return next.handle(newReq);
            }
        }

        return next.handle(request);
    }
}
